<template>
  <v-row>
    <v-col class="mt-2" cols="12" lg="10" offset-lg="1">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-card flat dark class="theme">
        <v-card-title>
          <v-icon class="white--text">rule</v-icon>
          <span class="headline ml-2 white--text">Edit workflow</span>
          <v-spacer />
          <v-btn
            depressed
            class="error ma-0 rounded-sm"
            @click="deleteDialog = true"
            >delete</v-btn
          >
        </v-card-title>
        <v-divider />
        <v-card-text class="py-0">
          <v-form ref="main">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Workflow Name"
                  clearable
                  :disabled="tempDisable"
                  placeholder="Example: Onboarding regular, Onboarding Oslo"
                  v-model="workflow.name"
                  class="pr-4 my-3"
                  :rules="[validationRules.required]"
                />
                <v-select
                  :items="types"
                  label="Workflow Type"
                  clearable
                  :disabled="tempDisable"
                  :rules="[validationRules.required]"
                  placeholder="Example: OnBoarding , OffBoarding"
                  v-model="workflow.type"
                  class="pr-4 my-3"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-textarea
                  label="Description"
                  clearable
                  :disabled="tempDisable"
                  placeholder="Onboarding workflow for Company employees"
                  v-model="workflow.description"
                  class="pl-4"
                  :rules="[validationRules.required]"
                  rows="2"
                />
                <div class="text-right">
                  <v-btn
                    @click="saveWorkflow"
                    depressed
                    class="action ml-4 mt-2 rounded-sm white--text"
                    >Save Workflow
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider />
      </v-card>
      <v-card>
        <v-card-text>
          <div class="title ml-6 theme-text">Workflow Tasks</div>
          <v-col cols="12">
            <v-data-table
              v-if="workflow.tasks"
              :headers="tableHeaders"
              :items="workflow.tasks"
              class="elevation-0 row-pointer"
              hide-default-footer
              @click:row="showTask"
            />
          </v-col>
        </v-card-text>
        <v-card-actions class="px-4 pt-4">
          <v-spacer />
          <v-btn
            block
            x-large
            depressed
            :ripple="false"
            class="special_border rounded-sm theme-text"
            @click="addTask"
          >
            Add Task
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-col>
    <v-dialog v-model="taskDialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="theme">
          <span class="headline white--text">Add tasks to the workflow</span>
          <v-spacer/>
          <v-btn
            depressed
            class="error ma-0 rounded-sm mx-3"
            @click="deleteDialogTask = true"
            >delete</v-btn
          >
          <v-btn icon @click="taskDialog = false">
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-row>
            <v-col cols="8">
              <v-form ref="task">
                <v-col cols="12">
                  <v-text-field
                    label="Task name*"
                    :rules="[validationRules.required]"
                    clearable
                    v-model="task.name"
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    label="Task description"
                    hint="example of helper text only on focus"
                    v-model="task.description"
                    clearable
                    :rules="[validationRules.required]"
                  />
                </v-col>
                <v-col cols="12">
                  <v-select
                    label="Assign to*"
                    :items="taskUsers"
                    item-text="name"
                    return-object
                    v-model="assigned_to"
                    hint="Default owner of this task"
                    :persistent-hint="true"
                    placeholder="Owner of the task"
                    clearable
                    :rules="[validationRules.required]"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="grey--text pt-1" v-on="on"
                            >info</v-icon
                          >
                        </template>
                        Person who will receive this task<br />when the workflow
                        gets triggered.
                      </v-tooltip>
                    </template>
                  </v-select>
                </v-col>
              </v-form>
            </v-col>
            <v-col cols="5" />
          </v-row>
          <v-btn class="save white--text ml-0" depressed @click="saveTask"
            >save</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" persistent max-width="400px">
      <v-card flat>
        <v-card-text class="theme">
          <div class="headline white--text text-sm-center pt-3">
            Are you sure?
          </div>
        </v-card-text>
        <v-card-text class="text-sm-center mt-10"
          >Confirming this action will delete the workflow.</v-card-text
        >
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="deleteDialog = false"
            >cancel</v-btn
          >
          <v-spacer />
          <v-btn color="error" text @click="deleteWorkflow">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialogTask" persistent max-width="400px">
      <v-card flat>
        <v-card-text class="theme">
          <div class="headline white--text text-sm-center pt-3">
            Are you sure?
          </div>
        </v-card-text>
        <v-card-text class="text-sm-center mt-10"
          >Confirming this action will delete the task.</v-card-text
        >
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="deleteDialogTask = false"
            >cancel</v-btn
          >
          <v-spacer />
          <v-btn color="error" text @click="deleteTask">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";
import { TableHeaders } from "@/views/headers";

export default {
  name: Component.Protected.Company.Workflow.Edit,
  data: () => ({
    breadcrumbs: Breadcrumbs.Workflows.Edit,
    tableHeaders: TableHeaders.WorkflowTasks,
    tempDisable: false,
    workflow: {
      tasks: [],
      name: "",
      description: "",
      type: "",
    },
    types: Constants.Workflows.Types,
    task: {
      name: "",
      description: "",
      assigned_to: "",
      assigned_to_id: "",
      completion_type: "",
    },
    completionTypes: Constants.Workflows.CompletionTypes,
    taskDialog: false,
    taskUsers: [],
    taskIds: [],
    assigned_to: {},
    id: "",
    deleteDialog: false,
    deleteDialogTask: false,
  }),
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    resetModels() {
      this.task = {
        uuid: uuidv4(),
        name: "",
        description: "",
        assigned_to: "",
        assigned_to_id: "",
        completion_type: "NotSpecified",
      };
    },
    getWorkflow() {
      this.$store
        .dispatch(Actions.Workflow.Get, this.$route.params.id)
        .then((r) => {
          if (r.status === 200) {
            if (r.data.tasks && r.data.tasks.length > 0) {
              r.data.tasks.forEach((el) => {
                el.uuid = uuidv4();
                this.taskIds.push(el.uuid);
                this.assigned_to = {
                  id: el.assigned_to_id,
                  name: el.assigned_to,
                };
              });
            }
            this.workflow = r.data;
          }
        })
        .catch((e) => {
          console.error(Constants.Workflows.Messages.Error.Get, e);
          this.snackbarMessage = Constants.Workflows.Messages.Error.Get;
          this.snackbar = true;
        });
    },
    setup() {
      if (this.userInfo.role !== Constants.Roles.HR) {
        this.$router.go(-1);
        return false;
      }

      let search = { type: Constants.Employee.Type.Active };
      this.$store
        .dispatch(Actions.Employee.Find, search)
        .then((r) => {
          if (r.status === 200) {
            this.taskUsers = r.data.map((e) => {
              return {
                id: e.id,
                name: `${e.first_name} ${e.last_name}`,
              };
            });
          } else {
            this.taskUsers = [
              { id: this.userInfo.userID, name: this.userInfo.username },
            ];
          }
        })
        .catch(() => {
          this.taskUsers = [
            { id: this.userInfo.userID, name: this.userInfo.username },
          ];
        });

      this.id = this.$route.params.id;
      this.getWorkflow();
    },
    addTask() {
      this.resetModels();
      this.taskDialog = true;
    },
    deleteTask(){
      var tasks = this.workflow.tasks.filter(task => task.uuid != this.task.uuid )
      this.workflow.tasks = tasks
      this.save()
       this.deleteDialogTask = false;
       this.taskDialog = false;
    },
    saveTask() {
      if (this.$refs.task.validate()) {
        const t = {
          ...this.task,
          assigned_to: this.assigned_to.name,
          assigned_to_id: parseInt(this.assigned_to.id),
        };

        // if item exists then update, else add
        if (this.taskIds.includes(t.uuid)) {
      // this.workflow.tasks.filter((el) => el.uuid === t.uuid).map(() => t); this for some reason didn't work
          const item = this.workflow.tasks.find(el=>el.uuid === t.uuid);
          const index = this.workflow.tasks.indexOf(item);
          this.workflow.tasks[index] = t;
        } else {
          if (!this.workflow.tasks) {
            this.workflow.tasks = [];
          }
          this.workflow.tasks.push(t);
          this.taskIds.push(t.uuid);
        }
        this.save();
        this.taskDialog = false;
      }
    },
    showTask(item) {
      if (item) {
        this.task = item;
        this.taskDialog = true;
      } else {
        return false;
      }
    },
    saveWorkflow() {
      if (this.$refs.main.validate()) {
        this.save();
        // this.$router.push({name: Component.Protected.Company.Workflow.List});
      }
    },
    save() {
      let data = { ...this.workflow };
      if (data.tasks && data.tasks.length > 0) {
        data.tasks.forEach((el) => delete el.uuid);
      }

      let payload = { id: this.$route.params.id, data: data };
      this.$store
        .dispatch(Actions.Workflow.Edit, payload)
        .then(() => {
          this.setup()
        })
        .catch((e) => {
          console.error(Constants.Workflows.Messages.Error.Edit, e);
          this.snackbar = true;
          this.snackbarMessage = Constants.Workflows.Messages.Error.Edit;
        });
    },

    deleteWorkflow() {
      this.$store
        .dispatch(Actions.Workflow.Delete, this.$route.params.id)
        .then(() => {
          this.$router.push({
            name: Component.Protected.Company.Workflow.List,
          });
        });
    },
  },
  created() { 
    if (!this.$route.params.id) {
      this.$router.go(-1);
    }

    if (this.userInfo && this.userInfo.role) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>


<style scoped>
* >>> div.theme--dark.error--text {
  color: #fff !important;
}

* >>> div.theme--dark.primary--text {
  color: #fff !important;
}

* >>> button.special_border {
  border-style: dashed;
}
</style>